export default __webpack_public_path__ + "static/media/limenaqs2.1788e4e7.jpeg";